module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_4-a5d0d09f2917886166c713c78b5ff202.webp";